import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";
import { CreateClientType, CreateCrewType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadCompanyImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const createSubcontractor = (
  payload: CreateClientType
): Promise<AxiosResponse<CreateClientType>> => {
  return axios.post(`${baseURL}createSubcontractor`, payload);
};

export const deleteSubcontractor = (
  clientIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteSubcontractor`, { data: clientIds });
};

export const changeSubcontractorStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changeSubcontractorStatus/${id}`, payload);
};

export const updateSubcontractorById = (
  id: string,
  payload: CreateClientType
): Promise<AxiosResponse<CreateClientType>> => {
  return axios.patch(`${baseURL}updateSubcontractorById/${id}`, payload);
};

export const createCrew = (
  payload: CreateCrewType
): Promise<AxiosResponse<CreateCrewType>> => {
  return axios.post(`${baseURL}createCrew`, payload);
};

export const changeCrewStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changeCrewStatus/${id}`, payload);
};

export const deleteCrew = (
  clientIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteCrew`, { data: clientIds });
};

export const updateCrewById = (
  id: string,
  payload: CreateCrewType
): Promise<AxiosResponse<CreateCrewType>> => {
  return axios.patch(`${baseURL}updateCrewById/${id}`, payload);
};
